import { CampaignStatus, STATUS_OPTIONS } from "../utils/constants";
import { useState } from "react";
import Button from "../../Button/Button";
import CheckIcon from "../../../assets/svg/check-icon";
import {
  FilterState,
  selectCampaignsFilters,
  setCampaignsStatus,
} from "../../../redux/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetPagination } from "../../../redux/slices/allCampaignSlice";

interface CampaignStatusFilterProps {
  onClose: () => void;
}

const CampaignStatusFilter = ({ onClose }: CampaignStatusFilterProps) => {
  const campaignStatus = useSelector(
    (state: { filter: FilterState }) => selectCampaignsFilters(state)?.status
  );
  const dispatch = useDispatch();
  const [selectedStatuses, setSelectedStatuses] = useState<CampaignStatus[]>(
    Array.isArray(campaignStatus.value)
      ? (campaignStatus.value as CampaignStatus[])
      : campaignStatus.value
      ? [campaignStatus.value as CampaignStatus]
      : []
  );

  const handleSelectStatus = (status: CampaignStatus) => {
    setSelectedStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status]
    );
  };

  const handleApply = () => {
    // Generate display value array
    const displayValues = selectedStatuses.map(
      (status) =>
        STATUS_OPTIONS.find((option) => option.value === status)
          ?.displayValue || status
    );

    dispatch(
      setCampaignsStatus({
        value: selectedStatuses,
        displayValue: displayValues,
      })
    );
    dispatch(resetPagination());
    onClose();
  };

  return (
    <div className="flex flex-col gap-2 mt-2 px-3">
      {STATUS_OPTIONS.map((option) => (
        <div
          key={option.value}
          className={`flex items-center justify-between p-3 gap-2 cursor-pointer border border-border-gray dark:border-border-gray-dk rounded-lg ${
            selectedStatuses.includes(option.value)
              ? "bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk border-verba-blue dark:border-verba-blue-dk"
              : ""
          }`}
          onClick={() => handleSelectStatus(option.value)}
        >
          {option.content}
          <div
            className={`shrink-0 w-[14px] h-[14px] border border-gray-100 dark:border-gray-100-dk rounded-[3px] flex items-center justify-center ${
              selectedStatuses.includes(option.value)
                ? "bg-verba-blue text-pure-white dark:bg-verba-blue-dk dark:text-pure-white-dk border-verba-blue dark:border-verba-blue-dk"
                : ""
            }`}
          >
            {selectedStatuses.includes(option.value) && (
              <CheckIcon className="w-3 h-3 text-pure-white dark:text-pure-white-dk" />
            )}
          </div>
        </div>
      ))}
      <div className="flex justify-end gap-2 mt-4">
        <Button
          innerText="Cancel"
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
          onClick={onClose}
        />
        <Button
          innerText="Apply"
          disabled={(() => {
            const currentValue = Array.isArray(campaignStatus?.value)
              ? campaignStatus.value
              : campaignStatus?.value
              ? [campaignStatus.value]
              : [];

            return (
              JSON.stringify([...(selectedStatuses || [])].sort()) ===
              JSON.stringify([...((currentValue as string[]) || [])].sort())
            );
          })()}
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default CampaignStatusFilter;
